import React from 'react';
import EmojiPicker from 'emoji-picker-react';

const NewFolderModal = ({
    showNewFolderModal,
    setShowNewFolderModal,
    editingFolder,
    newFolderName,
    setNewFolderName,
    newFolderEmoji,
    setNewFolderEmoji,
    showEmojiPicker,
    setShowEmojiPicker,
    handleSaveNewFolder,
}) => {
    if (!showNewFolderModal) return null;

    return (
        <div className="modal-overlay">
            <div className="modal">
                <button
                    className="modal-close-button"
                    onClick={() => setShowNewFolderModal(false)}
                    aria-label="Close"
                >
                    ❌
                </button>

                <h4>
                    {editingFolder ? 'Edit Folder' : 'Create New Folder'}
                </h4>

                <label className="modal-label">
                    Folder Name:
                    <input
                        type="text"
                        value={newFolderName}
                        onChange={(e) => setNewFolderName(e.target.value)}
                        placeholder="e.g. Urgent"
                    />
                </label>

                <label style={{ marginTop: '1rem', display: 'block' }}>
                    Emoji:

                    <span
                        className="emoji-trigger"
                        tabIndex={0}
                        onClick={() => setShowEmojiPicker((prev) => !prev)}
                        onKeyDown={(e) =>
                            (e.key === 'Enter' || e.key === ' ') &&
                            setShowEmojiPicker((prev) => !prev)
                        }
                    >
                        {newFolderEmoji || '😄'}
                    </span>

                    {showEmojiPicker && (
                        <div className="emoji-picker-wrapper">
                            <EmojiPicker
                                lazyLoadEmojis
                                skinTonesDisabled
                                onEmojiClick={(emojiData) => {
                                    setNewFolderEmoji(emojiData.emoji);
                                    setShowEmojiPicker(false);
                                }}
                            />
                        </div>
                    )}
                </label>

                <div className="modal-buttons">
                    <button
                        className="save-button"
                        onClick={handleSaveNewFolder}
                    >
                        Save
                    </button>

                    <button
                        className="cancel-button"
                        onClick={() => setShowNewFolderModal(false)}
                    >
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    );
};

export default NewFolderModal;